/**
 * Build jsonb-friendly participant_data for directory_participant_draft,
 * aligned with staff_promote_directory_draft_to_registration (core keys + additional_data merge).
 */

const CORE_FORM_KEYS = [
  "participant_name",
  "participant_email",
  "registration_type",
  "nationality",
  "nric",
  "dob",
  "birth_age",
  "mobile_no",
  "sponsor_uen",
  "course_type_code",
  "course_run_id",
  "full_certification_id",
  "certification_run_id",
];

function setNestedValue(root, dottedKey, value) {
  const keys = dottedKey.split(".");
  let current = root;
  for (let i = 0; i < keys.length - 1; i++) {
    const k = keys[i];
    if (!current[k] || typeof current[k] !== "object") {
      current[k] = {};
    }
    current = current[k];
  }
  current[keys[keys.length - 1]] = value;
}

/**
 * @param {object} params
 * @param {object} params.formData
 * @param {function} params.getFieldValue (formData, fieldKey) => any
 * @param {Array<{ id?: string, field_key: string, is_original_field?: boolean }>} params.additionalFields
 * @param {string[]|null} params.templateFieldIds — UUIDs of allowed field ids; null = all
 */
export function buildDirectoryParticipantPayload({
  formData,
  getFieldValue,
  additionalFields,
  templateFieldIds,
}) {
  const participantData = {};

  for (const key of CORE_FORM_KEYS) {
    const v = formData[key];
    if (v !== undefined && v !== null && v !== "") {
      participantData[key] = typeof v === "object" ? JSON.stringify(v) : String(v);
    }
  }

  const rows = (additionalFields || []).filter((field) => {
    if (templateFieldIds !== null && field.id != null && !templateFieldIds.includes(field.id)) {
      return false;
    }
    return true;
  });

  for (const field of rows) {
    const fieldValue = getFieldValue(formData, field.field_key);
    if (fieldValue === undefined || fieldValue === null || fieldValue === "") {
      continue;
    }
    const serialized =
      typeof fieldValue === "object" && !Array.isArray(fieldValue)
        ? JSON.stringify(fieldValue)
        : Array.isArray(fieldValue)
          ? JSON.stringify(fieldValue)
          : String(fieldValue);

    const keys = field.field_key.split(".");
    if (keys.length > 1) {
      setNestedValue(participantData, field.field_key, serialized);
    } else {
      participantData[field.field_key] = serialized;
    }
  }

  const today = new Date().toISOString().split("T")[0];
  if (!participantData.legal || typeof participantData.legal !== "object") {
    participantData.legal = { declaration_date: today };
  } else {
    participantData.legal.declaration_date = today;
  }

  return participantData;
}
